import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=07ddd8bb&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=ts"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=07ddd8bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ddd8bb",
  null
  
)

export default component.exports